// frontend/src/components/auth/register/registerStyles.ts

import { SxProps, Theme } from "@mui/material";
import {
  VERDE_MENTA,
  VERDE_MENTA_ESCURO,
  TEXTO_PRIMARIO,
  withAlpha,
} from "../../../themes/themeConstants";

const INPUT_BG = "#3A3A3A";
const BORDER_DEFAULT = "#555555";
const BORDER_HOVER = "#777777";
const ERROR_COLOR = "#F44336";

export const registerFieldSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: INPUT_BG,
    borderRadius: 2,
    "& fieldset": {
      borderColor: BORDER_DEFAULT,
    },
    "&:hover fieldset": {
      borderColor: BORDER_HOVER,
    },
    "&.Mui-focused fieldset": {
      borderColor: VERDE_MENTA,
    },
  },
  "& .MuiInputBase-input": {
    color: TEXTO_PRIMARIO,
  },
  "& .MuiFormHelperText-root": {
    color: ERROR_COLOR,
  },
};

export const registerEmailFieldSx = (emailExists: boolean): SxProps<Theme> => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: INPUT_BG,
    borderRadius: 2,
    "& fieldset": {
      borderColor: emailExists ? ERROR_COLOR : BORDER_DEFAULT,
    },
    "&:hover fieldset": {
      borderColor: emailExists ? ERROR_COLOR : BORDER_HOVER,
    },
    "&.Mui-focused fieldset": {
      borderColor: emailExists ? ERROR_COLOR : VERDE_MENTA,
    },
  },
  "& .MuiInputBase-input": {
    color: TEXTO_PRIMARIO,
  },
  "& .MuiFormHelperText-root": {
    color: ERROR_COLOR,
  },
});

export const forgotPasswordButtonSx: SxProps<Theme> = {
  borderColor: "#FF9800",
  color: "#FF9800",
  borderRadius: 2,
  px: 2,
  py: 0.5,
  fontSize: "0.875rem",
  textTransform: "none",
  "&:hover": {
    borderColor: "#F57C00",
    backgroundColor: withAlpha("#FF9800", 0.05),
  },
};

export const backButtonSx = (
  textSecondary: string
): SxProps<Theme> => ({
  borderColor: VERDE_MENTA,
  color: VERDE_MENTA,
  borderRadius: 2,
  px: 3,
  py: 1,
  fontWeight: 500,
  "&:hover": {
    borderColor: VERDE_MENTA,
    backgroundColor: withAlpha(VERDE_MENTA, 0.05),
  },
  "&.Mui-disabled": {
    borderColor: withAlpha(textSecondary, 0.3),
    color: textSecondary,
  },
});

export const submitButtonSx: SxProps<Theme> = {
  backgroundColor: VERDE_MENTA,
  color: "white",
  borderRadius: 2,
  px: 3,
  py: 1,
  fontWeight: 500,
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  "&:hover": { backgroundColor: VERDE_MENTA_ESCURO },
  "&.Mui-disabled": {
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    color: "rgba(255, 255, 255, 0.3)",
  },
};

export const errorAlertSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: "rgba(244, 67, 54, 0.15)",
  color: "#e57373",
  border: "1px solid rgba(244, 67, 54, 0.3)",
  borderRadius: 2,
  py: 1,
};
